<template>
  <PSComponentUserMonitor />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
